import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FormControl } from '@angular/forms';
import { OpmlImportService } from '../services/opmlImport.service';
import { TaxonomyService } from '../services/taxonomy.service';

@Component({
    selector: 'import-opml',
    template: `
        <mat-card>
            <mat-card-header>
                <h2>Import OPML File</h2>
            </mat-card-header>
            <mat-card-content style="padding: 25px;">
                <mat-form-field>
                    <ngx-mat-file-input #removableInput 
                                        [formControl]="opmlFileControl" 
                                        placeholder="Choose OPML File"
                                        [accept]="'.opml'"></ngx-mat-file-input>
                    <button mat-icon-button matSuffix *ngIf="!removableInput.empty" (click)="removableInput.clear($event)">
                        <mat-icon>clear</mat-icon>
                    </button>
                </mat-form-field>
            </mat-card-content>
            <mat-card-actions>
                <button mat-raised-button [disabled]="removableInput.empty" color="primary" (click)="save()">Import OPML</button>
            </mat-card-actions>
        </mat-card>
    `
})
export class ImportOpmlComponent {
    opmlFileControl = new FormControl();
    taxonomy: any;
    taxonomyVersion: any;
    
    constructor(private router: Router,
                private route: ActivatedRoute,
                private snackbar: MatSnackBar, 
                private opmlImportService: OpmlImportService,
                taxonomyService: TaxonomyService) {
        taxonomyService.getTenantTaxonomyDetails(false, false, true)
        .subscribe((results) => {
            this.taxonomy = results.taxonomy;
            this.taxonomyVersion = results.version;
            console.log(this.taxonomy, this.taxonomyVersion, results);
        });
    }

    save(): void {
        const opmlFile = this.opmlFileControl.value.files[0];
        const reader = new FileReader();
        reader.onloadend = (evt) => {
            this.opmlImportService.importOpml(evt.target['result'], this.taxonomy, this.taxonomyVersion)
            .subscribe( 
                () => {
                    const message = 'Your OPML file has been processed.'; 
                    this.snackbar.open(message, 'OK',  { duration: 5000 })
                    this.router.navigate(['/settings', 'sources'], { relativeTo: this.route });
                },
                err => {
                    console.log(err); 
                    const message = 'Your OPML file could not be parsed.  Please make sure that it is a valid OPML file.'; 
                    this.snackbar.open(message, 'OK',  { duration: 5000 });
                })
        };
        reader.readAsText(opmlFile);
    }
}